// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TTripReviewsCreateRequest, TTripReviewsCreateModel, IMappers, TTripReviewsCreateResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IPublicV1TripReviewsCreateResponse } from '../../../entities/response/PublicV1TripReviewsCreateResponse';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createTripReviewsCreateModel(parameters: TTripReviewsCreateRequest): TTripReviewsCreateModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'dailyrent',
    pathApi: '/v1/trip-reviews/create/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface ITripReviewsCreateOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TTripReviewsCreateRequest;
}

export async function fetchTripReviewsCreate<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ITripReviewsCreateOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TTripReviewsCreateResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createTripReviewsCreateModel(parameters),
    config,
  )) as FetchResponse<TTripReviewsCreateResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IPublicV1TripReviewsCreateResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TTripReviewsCreateResponse>;
}
